import React from "react";
import "./modal.css"; // Import the CSS file for styling

const Modal = ({ children, show, onClose, isClosable = true,width }) => {
  if (!show) return null; // If show is false, don't render the modal

  return (
    <div className="modal-overlay" onClick={onClose}> {/* Overlay to close on outside click */}
      <div
      style={width && {width:width}}
        className="modal-container"
        onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside
      >
        {/* Close action */}
        {isClosable && (
          <img
            src="assets/icons/cross.svg"
            alt="close icon"
            onClick={onClose}
            height={24}
            width={24}
            className="modal-close-icon"
          />
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
